import { useEffect, useState } from "react";
import { AlertTriangle, BellRing, Wallet } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";

const usd = (n) => `$${Number(n).toFixed(2)}`;

const ThresholdEditor = ({ value, onSaved }) => {
  const [v, setV] = useState(value);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await adminApi.setOpenRouterThreshold(Number(v));
      toast.success(`Avviso impostato sotto $${Number(v).toFixed(0)}`);
      onSaved(Number(v));
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || "Soglia non valida (1–1000)");
    } finally { setBusy(false); }
  };
  return (
    <div data-testid="openrouter-threshold" className="mt-2 flex flex-wrap items-center gap-2 text-[#2B3036]">
      <BellRing className="w-3.5 h-3.5" />
      <span>Notifica push quando il credito scende sotto</span>
      <span className="font-mono">$</span>
      <input data-testid="openrouter-threshold-input" type="number" min="1" max="1000" value={v} onChange={(e) => setV(e.target.value)}
             className="w-20 border border-[#d5dbde] px-2 py-1 font-mono focus:outline-none focus:border-[#2B3036]" />
      <button data-testid="openrouter-threshold-save" onClick={save} disabled={busy || Number(v) === value}
              className="px-3 py-1 bg-[#2B3036] text-white transition-opacity hover:opacity-80 disabled:opacity-40">Salva</button>
    </div>
  );
};

export const OpenRouterCredits = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { adminApi.openRouterCredits().then(setD).catch((e) => setErr(e?.response?.data?.detail || "Credito non disponibile")); }, []);
  if (err) return <div data-testid="openrouter-credits-error" className="mt-2 text-xs text-[#E3242B]">{err}</div>;
  if (!d) return null;
  const onSaved = (threshold) => setD({ ...d, threshold, low: d.lowest < threshold });
  return (
    <div data-testid="openrouter-credits" className={`mt-3 border p-3 text-xs ${d.low ? "border-[#E3242B] bg-[#E3242B]/5" : "border-[#d5dbde] bg-white"}`}>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1 font-mono">
        <span className="inline-flex items-center gap-1.5 text-[#2B3036]"><Wallet className="w-3.5 h-3.5" /> Credito rimasto: <b data-testid="openrouter-credits-remaining" className={d.low ? "text-[#E3242B]" : "text-[#10b981]"}>{usd(d.remaining)}</b></span>
        <span className="text-[#6b7280]">caricato {usd(d.total)} · usato {usd(d.used)}</span>
        {d.key_limit != null && <span className="text-[#6b7280]">limite chiave {usd(d.key_remaining)} / {usd(d.key_limit)}{d.key_reset ? ` (${d.key_reset})` : ""}</span>}
      </div>
      {d.low && (
        <div data-testid="openrouter-credits-low" className="mt-2 flex items-center gap-1.5 text-[#E3242B] font-medium">
          <AlertTriangle className="w-3.5 h-3.5" /> Credito sotto i {usd(d.threshold)}: ricaricalo per non bloccare audit SEO e chatbot.
        </div>
      )}
      <ThresholdEditor value={d.threshold} onSaved={onSaved} />
    </div>
  );
};
